export const translateColor = (color) => {
    if (["green", "verde"].includes(color.toLowerCase())) return "#80bd01";
    if (["orange", "naranja"].includes(color.toLowerCase())) return "#ff8d6a";
    if (["azul", "blue"].includes(color.toLowerCase())) return "#6ec4e8";
    if (["grey", "gris"].includes(color.toLowerCase())) return "#acb4b9";
    if (["grey", "gris"].includes(color.toLowerCase())) return "#acb4b9";
    return color;
};
